import React from 'react'
import {change as changeFieldValue, Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import $ from 'jquery';
import axios from 'axios';
import {
    renderField,
    renderFieldCpfCnpj,
    renderFieldTelefone,
    required,
    telefone,
    validarCpfCnpj
} from '../../util/inputs';
import cadastrarPrestador from '../../actions/prestador/cadastrarPrestador';

import alterarPrestador from '../../actions/prestador/alterarPrestador';
import selecionarPrestador from '../../actions/prestador/selecionarPrestador';
import {URL} from '../../util/ambienteActions';
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil';
import {showSuccessMsg} from '../../util/messagesUtil';

export class ModalCadastrarCidade extends React.Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.limparFormulario = this.limparFormulario.bind(this);
    }

    pesquisarPorCep(event) {
        const CEP = event.target.value.replace(/\D/g, '')
        if (CEP.length === 8) {
            const url = `${URL}/cep/public/${CEP}`
            axios.get(url, SLOW_REQUEST_CONFIG).then((resp) => {
                if (resp.status === 200) {
                    this.props.changeFieldValue('formularioCadastrarPrestador',
                        'logradouro', resp.data.logradouro);
                    this.props.changeFieldValue('formularioCadastrarPrestador',
                        'complemento', resp.data.complemento);
                    this.props.changeFieldValue('formularioCadastrarPrestador',
                        'bairro', resp.data.bairro);
                    this.props.changeFieldValue('formularioCadastrarPrestador',
                        'localidade', resp.data.localidade);
                    this.props.changeFieldValue('formularioCadastrarPrestador',
                        'uf', resp.data.uf);
                }
            })
        }
    }

    limparCampos() {
        this.props.changeFieldValue('formularioCadastrarPrestador',
            'nome', '');
        this.props.changeFieldValue('formularioCadastrarPrestador',
            'responsavel', '');
        this.props.changeFieldValue('formularioCadastrarPrestador',
            'logradouro', '');
        this.props.changeFieldValue('formularioCadastrarPrestador',
            'complemento', '');
        this.props.changeFieldValue('formularioCadastrarPrestador',
            'bairro', '');
        this.props.changeFieldValue('formularioCadastrarPrestador',
            'localidade', '');
        this.props.changeFieldValue('formularioCadastrarPrestador',
            'uf', '');
    }

    submit(values) {
        const prestador = {
            nome: values.nome,
            responsavel: values.responsavel,
            cep: values.cep,
            logradouro: values.logradouro,
            complemento: values.complemento,
            bairro: values.bairro,
            localidade: values.localidade,
            uf: values.uf,
            id: values.idPrestador,
            numero: values.numero,
            idEmpresa: this.props.empresaSelecionada.id,
            telefone: values.telefone,
            cpfCnpj: values.cpfCnpj.trim(),
        };
        if (this.props.prestadorSelecionado && this.props.prestadorSelecionado.id) {
            this.alterar(prestador)
        } else {
            this.cadastrar(prestador);
        }
    }

    cadastrar(prestador) {
        this.props.cadastrarPrestador(prestador)
            .then(() => {
                showSuccessMsg('Prestador cadastrado com sucesso');
                this.props.buscarPrestadores();
                this.fecharModal();
            })
    }

    alterar(prestador) {
        this.props.alterarPrestador(prestador)
            .then(() => {
                showSuccessMsg('Prestador alterado com sucesso');
                this.props.buscarPrestadores()
                this.fecharModal();
            })
    }

    limparFormulario() {
        this.props.reset('formularioCadastrarPrestador');
        this.props.selecionarPrestador();
    }

    fecharModal() {
        $('#modalCadastrarPrestador')
            .modal('hide');
        $('#modalCadastrarPrestador')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.limparFormulario();
    }

    render() {
        const {
            handleSubmit, submitting, invalid, pristine
        } = this.props;

        return (
            <div className="modal fade show" id='modalCadastrarPrestador' role='dialog'
                 aria-labelledby='modalCadastrarPrestador' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-md'}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>{this.props.prestadorSelecionado && this.props.prestadorSelecionado.id ? 'Alterar Prestador' : 'Cadastrar Prestador'}</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                    onClick={this.limparFormulario}>
                                <i className="material-icons">
                                    &#xe5cd;
                                </i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit(this.submit)}>
                                <div className="form-row">
                                    <div className="col-12 col-sm-9 col-md-9">
                                        <Field name="nome" type="text" validate={[required]} component={renderField}
                                               label="Nome:"
                                               css="form-control" readOnly={false}/>
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="col-12 col-sm-9 col-md-9">
                                        <Field name="responsavel" type="text" validate={[required]} component={renderField}
                                               label="Responsável:"
                                               css="form-control" readOnly={false}/>
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="col-12 col-sm-9 col-md-9">
                                        <Field name="cpfCnpj" type="text" validate={[required, validarCpfCnpj]}
                                               component={renderFieldCpfCnpj} label="CPF/CNPJ:"
                                               css="form-control"/>
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="col-12 col-sm-9 col-md-9">
                                        <Field name="telefone" type="text" validate={[required, telefone]}
                                               component={renderFieldTelefone}
                                               css="form-control" label="Telefone"/>
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="col-12 col-sm-4 col-md-4">
                                        <Field name="cep" type="text" validate={[required]} component={renderField} label="CEP:"
                                               css="form-control" readOnly={false}
                                               onChange={e => this.pesquisarPorCep(e)}/>
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="col-12 col-sm-9 col-md-9">
                                        <Field name="logradouro" type="text" validate={[required]} component={renderField} label="Logradouro:"
                                               css="form-control" readOnly={false}/>
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="col-12 col-sm-9 col-md-9">
                                        <Field name="complemento" type="text" component={renderField}
                                               label="Complemento:"
                                               css="form-control" readOnly={false}/>
                                    </div>
                                    <div className="col-12 col-sm-9 col-md-3">
                                        <Field name="numero" type="text" validate={[required]} component={renderField} label="Número:"
                                               css="form-control" readOnly={false}/>
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="col-12 col-sm-6 col-md-6">
                                        <Field name="bairro" type="text" validate={[required]} component={renderField} label="Bairro:"
                                               css="form-control" readOnly={false}/>
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="col-12 col-sm-6 col-md-6">
                                        <Field name="localidade" type="text" validate={[required]} component={renderField} label="Localidade:"
                                               css="form-control" readOnly={false}/>
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="col-12 col-sm-4 col-md-4">
                                        <Field name="uf" type="text" validate={[required]} component={renderField} label="UF:"
                                               css="form-control" readOnly={false}/>
                                    </div>
                                </div>
                                <Field name="idPrestador" type="hidden" component={renderField}
                                       css="form-control col-md-12"/>
                                <div className="modal-footer mt-2">
                                    <button type="submit" disabled={invalid || submitting || pristine}
                                            className="btn btn-laranja">Salvar
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        prestadorSelecionado: state.prestadores.prestadorSelecionado,
        empresaSelecionada: state.empresaSelecionada
    }
}


export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        cadastrarPrestador,
        alterarPrestador,
        selecionarPrestador
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioCadastrarPrestador',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(ModalCadastrarCidade));
